import { makeStyles } from "@material-ui/core"

export default makeStyles(() => ({
  promoted: {
    color: "orangered",
  },
}))
